(ns teamoesterreich.admin-mode.user.user-card-documents
  (:require [clojure.string :as str]
            [clojure.string]
            [goog.date.DateTime]
            [goog.object :as g]
            [teamoesterreich.setup :refer [USER_DOCUMENT_TYPES]]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.cloud-download :refer [cloud-download]]
            [reagent-material-ui.icons.cloud-upload :refer [cloud-upload]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.perm-identity :refer [perm-identity]]
            [reagent.core :as r]


            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.modal.info-modal :as info-modal]

            [teamoesterreich.admin-mode.ui-helper.are-you-sure-modal :as ays-modal]
            [teamoesterreich.admin-mode.ui-helper.preview-modal :as preview-modal]
            [teamoesterreich.admin-mode.user.document-assign-modal :as assign-modal]

            [teamoesterreich.admin-mode.user.document-identity-modal :as document-identity-modal]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.helper :as h]

            [teamoesterreich.util.log :as log]

            ["react-oidc-context" :as roc]
            ))


(defn event-result
  [^js/Event e]
  (-> e (g/get "target") (g/get "result")))

(defn file-upload [!actual-user files userDokument-type & [on-finished-fn]]
  (when-let [file (.item files 0)]
    (let [fr (js/FileReader.)]
      (set! (.-onload fr)
            (fn [event]
              (log/out "read file" event (event-result event))
              (d-user/>userDocument-upload (:user-uuid @!actual-user)
                                           userDokument-type
                                           {:buffer       (event-result event)
                                            :file-name    (g/get file "name")
                                            :content-type (g/get file "type")
                                            :on-finished  (fn [url]
                                                            (log/out "got back URL" url)
                                                            (on-finished-fn url)
                                                            )})
              ))

      (.readAsArrayBuffer fr file))))


(defn select-type [!documentType]

  [mui/select
   {:fullWidth true
    :value     (or @!documentType "other")
    :onChange  (fn [e]
                 (js/console.log "Change type  -> " (h/event-value e))
                 (reset! !documentType (h/event-value e)))
    }
   [mui/menu-item {:key "identification" :value "identification"} "Ausweis"]
   [mui/menu-item {:key "profilePicture" :value "profilePicture"} "Profilbild"]
   [mui/menu-item {:key "selfDeclaration" :value "selfDeclaration"} "Selbsterklärung"]
   [mui/menu-item {:key "lebensretter-qualification" :value "lebensretter-qualification"} "Lebensretter Qualifikation"]
   [mui/menu-item {:key "other" :value "other"} "Sonstiges"]
   ])

(defn date-conv [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count date) 12)
    (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    ""
    ))

(defn datetime-conv [date]
  (if (= "" (str date))
    nil
    (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)
         " " (subs date 9 11) ":" (subs date 11 13))
    ))


(defn download-button [userDocument-path]
  (let [url (backend-file/use-download-url userDocument-path)]
    [mui/button {:size      "small" :color "secondary"
                 :style     {:float "right"}
                 :endIcon   (r/as-element [cloud-download])
                 :component "a"
                 :href      url
                 :download  ""
                 } "Download"]))

(defn document-block [!actual-user {:keys [userDocument-uuid userDocument-type userDocument-fileName userDocument-path userDocument-isIdentity userDocument-isSelfExplain userDocument-isTraining
                                           userDocument-active userDocument-readonly userDocument-since] :as document}]

  ;(js/console.log "------ document-block instance" @!actual-user)
  (let [!state (r/atom {:show-delete-modal false :show-select-modal false :enlarge false})
        !enlarge (r/cursor !state [:enlarge])
        !show-delete-modal (r/cursor !state [:show-delete-modal])
        !show-select-modal (r/cursor !state [:show-select-modal])
        !show-identity-modal (r/cursor !state [:show-identity-modal])
        !show-identity-drop-modal (r/cursor !state [:show-identity-drop-modal])
        active-clearance (d-user/get-active-clearance @!actual-user)
        is-cleared? (d-lrClearance/is-cleared active-clearance)
        ]
    (fn []
      (when userDocument-active
        (fn []
          [mui/grid
           {:container false :item true
            :key       (str "document-block-" userDocument-uuid)
            :xl        4
            :md        6                                    ;extra-small: 0px
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px 15px 0 15px"}
            }
           [preview-modal/modal userDocument-path !enlarge]
           [ays-modal/are-you-sure-modal !show-delete-modal "Willst du wirklich dieses Dokument löschen?" "Löschen"
            (fn [] (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                     {:userDocument-active false}
                                                     (fn [] (fn [] (d-user/actual-user-invalidate !actual-user)))))]

           ;[:div "is-cleared?" is-cleared? "   " (get-in active-clearance [:lrClearance-identityDocument :userDocument-uuid]) "==" (:userDocument-uuid document)]
           (if (and is-cleared? (= (get-in active-clearance [:lrClearance-identityDocument :userDocument-uuid]) (:userDocument-uuid document)))
             [info-modal/info-modal !show-identity-drop-modal (r/as-element [:p "Dieser Identitätsnachweis ist für die LEBENSRETTER Freigabe aktiv! " [:br] "Bitte in Lebensretter Verwaltung bearbeiten."]) "Ja"]
             ;no clearance
             [ays-modal/are-you-sure-modal !show-identity-drop-modal "Willst du wirklich dieses Dokument nicht mehr als Identitätsnachweis verwenden?" "Ja"
              (fn []
                (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                  {:userDocument-readonly   false
                                                   :userDocument-isIdentity false
                                                   }
                                                  (fn []
                                                    (d-user/>user-edit-field (:user-uuid @!actual-user) {:user-identityValid false}
                                                                             (fn [] (d-user/actual-user-invalidate !actual-user))))))]
             )
           [(document-identity-modal/modal !actual-user document !show-identity-modal)]
           [(assign-modal/modal !actual-user document !show-select-modal)]
           [mui/card
            {:variant "outlined"
             :style   (merge {}
                             (when (or userDocument-isIdentity userDocument-isTraining userDocument-isSelfExplain)
                               [:backgroundColor "#c7d8f1"]))
             }
            [mui/card-content {:style {:paddingBottom "0"}}
             [backend-file/img {:hash             userDocument-path
                                       :preview? true
                                       :onClick  #(swap! !state assoc :enlarge (not (:enlarge @!state)))
                                       :style    {:position "relative" :float "right" :maxHeight "100px" :maxWidth "180px" :object-fit "contain"}
                                       :alt      (str userDocument-fileName)}]

             [:div {:style {:width "calc(100% - 202px)" :minHeight "140px"}}
              [:p {:gutterBottom true :style {}} (or (get USER_DOCUMENT_TYPES userDocument-type) (str "?" userDocument-type))
               [:br]
               (or userDocument-fileName userDocument-path)

               [:br]
               (when userDocument-since (datetime-conv userDocument-since))]
              ]

             ]


            [mui/card-actions


             (when-not (or userDocument-isIdentity userDocument-isTraining userDocument-isSelfExplain)
               [mui/button {:size    "small" :color "primary"
                            :endIcon (r/as-element [edit])
                            :onClick #(reset! !show-select-modal true)
                            } "Typ ändern"])

             (when (and (= "identification" userDocument-type) (not userDocument-isIdentity))
               [mui/button {:size    "small" :color "primary"
                            :endIcon (r/as-element [perm-identity])
                            :onClick #(reset! !show-identity-modal true)
                            } "Als Identität verwenden"])

             (when (and (= "identification" userDocument-type) userDocument-isIdentity)
               [mui/button {:size    "small"
                            :endIcon (r/as-element [perm-identity])
                            :onClick #(reset! !show-identity-drop-modal true)
                            } "Identitätsnachweis aufheben"])
             [:br]
             (when userDocument-path
               [:f> download-button userDocument-path])

             (when-not userDocument-readonly
               [mui/button {:size    "small" :color "secondary"
                            :endIcon (r/as-element [delete-outline])
                            :onClick #(reset! !show-delete-modal true)
                            } "Löschen"])
             ]

            ]]
          )))))

(defn get-it [!actual-user]
  (let [!state (r/atom {:documentType "other" :uploading false})
        !uploading (r/cursor !state [:uploading])
        !documentType (r/cursor !state [:documentType])]
    (fn []
      [mui/card {:style {:textAlign "left"}}
       [mui/card-header
        {:title "Hochgeladene Dokumente"
         }]
       [mui/collapse {:in true}
        [mui/card-content
         [mui/grid
          {:container  true
           :direction  "row"
           :justify    "space-between"
           :alignItems "flex-start"
           :spacing    3
           }
          (doall (for [doc (sort-by :userDocument-since
                                    (filter :userDocument-active (:user-userDocument @!actual-user)))]
                   ^{:key (str "userDocument-" (:userDocument-uuid doc))}
                   [(document-block !actual-user doc)]))
          ]]
        (when (d-rights/allow-admin-for d-rights/USER (:user-orgId @!actual-user))
          [mui/card-actions
           (if @!uploading
             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "flex-start"
               :alignItems "flex-start"
               :spacing    1
               }
              "Datei upload .... " [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 20}]
              ]

             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "flex-start"
               :alignItems "flex-start"
               :spacing    1
               }
              [mui/grid
               {:container false :item true :xl 4 :xs 6}
               [select-type !documentType]]

              [mui/grid
               {:container false :item true :xl 4 :xs 6}

               [mui/button {:size      "small" :color "secondary"
                            :style     {:float "left"}
                            :component "label"
                            :endIcon   (r/as-element [cloud-upload])
                            }
                "Dokument Hochladen"
                [:input {:type     "file" :hidden "hidden"
                         :disabled (if @!documentType false true)
                         :endIcon  (r/as-element [cloud-upload])
                         :onChange (fn [e]
                                     (reset! !uploading true)
                                     (log/debug "Upload document:: " (:user-uuid @!actual-user) (.item e.target.files 0))
                                     (.preventDefault e)
                                     (.stopPropagation e)
                                     (file-upload !actual-user e.target.files @!documentType
                                                  (fn []
                                                    (d-user/actual-user-invalidate !actual-user)
                                                    (reset! !uploading false)))
                                     )
                         }]
                ]
               ]])
           ])
        ]
       ])))